<div style="margin-top: 2rem" *ngIf="showThisComponent">
  <div fxLayoutAlign="center flex-start" fxFlex="100">
    <div class="info-and-card-wrapper">
      <div class="card-wrapper {{ type_class }} {{ size }}">
        <ng-container
          [ngTemplateOutlet]="isCollapsible ? collapsible : card"
          [ngTemplateOutletContext]="{ $implicit: content }"></ng-container>
        <ng-template #content><ng-content></ng-content></ng-template>

        <!-- Card -->
        <ng-template #card let-content>
          <mat-card appearance="outlined" class="box-card" [ngClass]="{ onError: error }">
            <mat-error *ngIf="error">
              {{ errorMessage }}
            </mat-error>

            <mat-card-header *ngIf="title" class="header-card">
              <mat-card-title>
                <app-header-title
                  [title]="title"
                  [titleDetail]="titleDetail"
                  [info]="info"></app-header-title>
                <ng-content select="cardTitle"></ng-content>
              </mat-card-title>
            </mat-card-header>

            <mat-card-content class="content-card">
              <div fxLayout="column" fxFlexAlign="stretch">
                <div fxFlex="100" *ngIf="showChildComponent">
                  <ng-container [ngTemplateOutlet]="content"></ng-container>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </ng-template>

        <!-- Collapsible -->
        <ng-template #collapsible let-content>
          <mat-expansion-panel [expanded]="collapsibleIsExpanded">
            <mat-error *ngIf="error">
              {{ errorMessage }}
            </mat-error>

            <mat-expansion-panel-header>
              <mat-panel-title *ngIf="title">
                <app-header-title
                  [title]="title"
                  [titleDetail]="titleDetail"
                  [info]="info"></app-header-title>
                <ng-content select="cardTitle"></ng-content>
              </mat-panel-title>
              <mat-panel-description *ngIf="collapsibleDescription">
                {{ collapsibleDescription }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div *ngIf="showChildComponent">
              <ng-container [ngTemplateOutlet]="content"></ng-container>
            </div>
          </mat-expansion-panel>
        </ng-template>
      </div>

      <div class="info-wrapper" *ngIf="!hideInfoWrapper">
        <mat-card
          appearance="outlined"
          class="box-card card-info"
          *ngIf="[info] != ''"
          fxLayoutAlign="flex-start center">
          <mat-icon style="padding-right: 1em">info_outline</mat-icon>
          <span>
            {{ info }}
          </span>
        </mat-card>
      </div>
    </div>
  </div>
</div>
